import { useEffect, useRef } from 'react';
import { Animated, Pressable, StyleSheet, ViewStyle } from 'react-native';

interface ErnestMascotProps {
  size?: number;
  style?: ViewStyle;
  onPress?: () => void;
  enableFloat?: boolean;
  enableBreathing?: boolean;
  enableTapBounce?: boolean;
}

export default function ErnestMascot({
  size = 44,
  style,
  onPress,
  enableFloat = true,
  enableBreathing = true,
  enableTapBounce = true,
}: ErnestMascotProps) {
  // Animation values
  const floatAnim = useRef(new Animated.Value(0)).current;
  const breatheAnim = useRef(new Animated.Value(1)).current;
  const bounceAnim = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    // Flottement (up/down)
    if (enableFloat) {
      const floatAnimation = Animated.loop(
        Animated.sequence([
          Animated.timing(floatAnim, {
            toValue: -6,
            duration: 1500,
            useNativeDriver: true,
          }),
          Animated.timing(floatAnim, {
            toValue: 0,
            duration: 1500,
            useNativeDriver: true,
          }),
        ])
      );
      floatAnimation.start();
      return () => floatAnimation.stop();
    }
  }, [enableFloat]);

  useEffect(() => {
    // Respiration (scale)
    if (enableBreathing) {
      const breatheAnimation = Animated.loop(
        Animated.sequence([
          Animated.timing(breatheAnim, {
            toValue: 1.05,
            duration: 2000,
            useNativeDriver: true,
          }),
          Animated.timing(breatheAnim, {
            toValue: 1,
            duration: 2000,
            useNativeDriver: true,
          }),
        ])
      );
      breatheAnimation.start();
      return () => breatheAnimation.stop();
    }
  }, [enableBreathing]);

  // Bounce au tap
  const handlePressIn = () => {
    if (enableTapBounce) {
      Animated.spring(bounceAnim, {
        toValue: 0.9,
        friction: 3,
        tension: 100,
        useNativeDriver: true,
      }).start();
    }
  };

  const handlePressOut = () => {
    if (enableTapBounce) {
      Animated.spring(bounceAnim, {
        toValue: 1,
        friction: 3,
        tension: 100,
        useNativeDriver: true,
      }).start();
    }
    onPress?.();
  };

  // Combine les animations
  const animatedStyle = {
    transform: [
      { translateY: floatAnim },
      { scale: Animated.multiply(breatheAnim, bounceAnim) },
    ],
  };

  return (
    <Pressable
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
      disabled={!onPress && !enableTapBounce}
    >
      <Animated.Image
        source={require('../assets/images/ernest.png')}
        style={[
          styles.image,
          { width: size, height: size },
          animatedStyle,
          style,
        ]}
        resizeMode="contain"
      />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  image: {
    // Base styles
  },
});
